import { combineReducers } from "redux";
import statusReducer from "./statusReducer";
import userReducer from "./userReducer";
import solutionReducer from "./solutionReducer";
import authReducer from "./authReducer";
import userFactorsReducer from "./userFactorsReducer";
import accountMergeReducer from "./accountMergeReducer";

const rootReducer = combineReducers({
  statusReducer,
  userReducer,
  solutionReducer,
  authReducer,
  userFactorsReducer,
  accountMergeReducer
});

export default rootReducer;
